export const validation = {
	badge: {
		validated: "Dados validados",
		pending: "Aguardando validação",
		preExisting: "Pré-existente",
	},
	filter: {
		label: "Status",
		all: "Todos",
		pending: "Aguardando validação",
		validated: "Validados",
	},
	banner: {
		title: "Você possui dados fiscais para validar!",
		message: "Confirme os dados para conseguir utilizar esses perfis fiscais.",
	},
	card: {
		confirmAction: "Confirmar dados",
		validateAction: "Validar dados",
		viewDetails: "Ver detalhes",
	},
	drawerNotice: {
		pendingValidation: "Valide os dados para usar esse perfil fiscal",
		pendingValidationGroup: "Valide os dados para usar esse grupo fiscal",
	},
	modalConfirm: {
		title: "Confirmar dados fiscais",
		message:
			"Certeza que deseja validar os dados desse perfil fiscal? Ao confirmar ele ficará disponível para ser utilizado no sistema.",
		confirm: "Confirmar dados",
		success: "Dados validados com sucesso!",
	},
	modalReject: {
		title: "Recusar dados fiscais",
		message:
			"Tem certeza que deseja recusar essas alterações? O cadastro voltará ao estado anterior.",
		confirm: "Confirmar recusa",
		success: "Dados recusados.",
		// Cadastro novo (sem versão vigente): recusar exclui permanentemente.
		newRegistrationProfile: {
			title: "Recusar perfil fiscal",
			messageBold: "Certeza que deseja recusar esse perfil fiscal?",
			message: "Ao confirmar ele será excluído permanentemente do sistema.",
			confirm: "Recusar perfil fiscal",
		},
		newRegistrationGroup: {
			title: "Recusar grupo fiscal",
			messageBold: "Certeza que deseja recusar esse grupo fiscal de produto?",
			message: "Ao confirmar ele será excluído permanentemente do sistema.",
			confirm: "Recusar grupo fiscal",
		},
	},
	infoBlock: {
		title: "Validação dos dados fiscais",
		validatedAt: "Data/hora da validação",
		validatedBy: "Validado por",
		newBadge: "Novo",
	},
	drawerFooter: {
		confirmData: "Confirmar dados",
		reject: "Recusar",
		editProfile: "Editar perfil",
		editGroup: "Editar grupo",
	},
	// Tooltips de apoio na listagem de cadastros (Figma node 3066-7771).
	tooltip: {
		pendingProfile: "Valide os dados para conseguir utilizar esse perfil fiscal",
		pendingGroup:
			"Valide os dados para conseguir utilizar esse grupo fiscal de produto",
		preExistingProfile:
			"Perfil fiscal criado antes da validação de dados. Não precisa ser validado para ser utilizado.",
		preExistingGroup:
			"Grupo fiscal de produto criado antes da validação de dados. Não precisa ser validado para ser utilizado.",
		validatedBy: "Dados fiscais validados {{date}} por",
		validated: "Dados fiscais validados {{date}}",
	},
	form: {
		saveAndValidate: "Salvar e Validar",
		saveAndValidateSuccess: "Salvo e Validado com Sucesso.",
	},
};
